












































































































import { Component, Prop } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
import Order, { UpdateOrderInRefundType } from "@/store/entities/booking/order";

@Component({
  components: {},
})
export default class UpdateOrderInRefund extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({
    type: Number,
    default: () => {
      return 0;
    },
  })
  orderId: number;
  order: Order = new Order();
  postData: UpdateOrderInRefundType = new UpdateOrderInRefundType();
  tabName: string = "refund";
  cancel() {
    this.$emit("input", false);
  }
  closeTable() {
    this.$emit("input", false);
    this.$emit("getPage");
  }
  /**
   * @description:表单校验规则
   */
  postDataRule = {
    personNames: [
      {
        required: true,
        message: "请输入打球人员姓名,用,分隔",
        trigger: "blur",
      },
    ],
    linkMan: [
      {
        required: true,
        message: "请输入联系人",
        trigger: "blur",
      },
    ],
    personCount: [
      {
        type: "number",
        required: true,
        min: 1,
        message: "请输入打球人数",
        trigger: "change",
      },
    ],
    price: [
      {
        type: "number",
        required: true,
        min: 1,
        message: "请输入退款后价格",
        trigger: "change",
      },
    ],
  };
  /**
   * @description:确定事件
   */

  save() {
    if (this.postData.personNames.trim()) {
      let personCounts = this.postData.personNames.split(",");
      if (personCounts.length !== this.postData.personCount) {
        this.$Message.error({
          content: "输入人名数量和人数不相等,请检查......",
        });
        return;
      }
    }
    (this.$refs.postDataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        let res = await this.$store.dispatch({
          type: "order/updateOrderInRefund",
          data: this.postData,
        });
        if (res) {
          this.$Message.success({
            content: "部分退款修改信息成功,请手动线下进行退款即可......",
          });
          this.closeTable();
        }
      }
    });
  }
  /**
   * @description:弹窗发生改变事件
   */
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);

      this.postData = new UpdateOrderInRefundType();
      this.$emit("getPage");
    } else {
      console.log(this.$props.orderId, "orderId");
      if (this.$props.orderId) {
        this.order = await this.$store.dispatch({
          type: "order/get",
          id: this.$props.orderId,
        });
        this.postData = this.order;
      }
    }
  }
}
